import SoundManager from "../managers/SoundManager"

const duration = 300

export default class Face {

    name
    spots
    stroke
    sprite
    origin
    size
    polygon
    leftPaths
    rightPaths
    leftSound
    rightSound
    soundManager

    constructor(name, spots, stroke, leftSound, rightSound, soundManager) {
        this.name = name
        this.spots = spots
        this.stroke = stroke

        this.origin = {
            x: Math.min(...this.spots.map(spot => spot.x)),
            y: Math.min(...this.spots.map(spot => spot.y)),
        }
        this.size = {
            width: Math.max(...this.spots.map(spot => spot.x)) - this.origin.x,
            height: Math.max(...this.spots.map(spot => spot.y)) - this.origin.y,
        }

        this.polygon = []
        for (let spot of this.spots) {
            let point = new Phaser.Geom.Point(spot.x - this.origin.x, spot.y - this.origin.y)
            this.polygon.push(point)
        }

        this.leftPaths = []
        for (let i=0; i<spots.length - 1; i++) {
            let path = new Phaser.Curves.Path(this.spots[i].x, this.spots[i].y)
            path.lineTo(this.spots[i+1].x, this.spots[i+1].y)
            this.leftPaths.push(path)
        }
        const lastLeftPath = new Phaser.Curves.Path(this.spots[this.spots.length - 1].x, this.spots[this.spots.length - 1].y)
        lastLeftPath.lineTo(this.spots[0].x, this.spots[0].y)
        this.leftPaths.push(lastLeftPath)

        this.rightPaths = []
        const firstRightPath = new Phaser.Curves.Path(this.spots[0].x, this.spots[0].y)
        firstRightPath.lineTo(this.spots[this.spots.length - 1].x, this.spots[this.spots.length - 1].y)
        this.rightPaths.push(firstRightPath)
        for (let i=1; i<spots.length; i++) {
            let path = new Phaser.Curves.Path(this.spots[i].x, this.spots[i].y)
            path.lineTo(this.spots[i-1].x, this.spots[i-1].y)
            this.rightPaths.push(path)
        }

        this.leftSound = leftSound
        this.rightSound = rightSound
        this.soundManager = soundManager
    }

    draw(graphics) {
        graphics.lineStyle(this.stroke, 0xffffff, 1)
        graphics.fillStyle(0xffffff, 0.3)
       
        graphics.beginPath()
        graphics.moveTo(this.polygon[0].x, this.polygon[0].y)
        for (let i=1; i<this.polygon.length; i++) {
            graphics.lineTo(this.polygon[i].x, this.polygon[i].y)
        }
        graphics.closePath()
        graphics.strokePath()
        graphics.fillPath()

        graphics.generateTexture(this.name, this.size.width + 2*this.stroke, this.size.height + 2*this.stroke)
    }

    rotateLeft(that) {
        that.soundManager.play(that.leftSound)
        return new Promise(resolve => {
            const balls = that.spots.map(spot => spot.ball)
            for (let i=0; i<balls.length - 1; i++) {
                balls[i].sprite.setPath(that.leftPaths[i], null)
                balls[i].sprite.startFollow({
                    duration: duration,
                    from: 0,
                    to: 1,
                    repeat: 0,
                    positionOnPath: true,
                    rotateToPath: true
                })
            }

            balls[balls.length - 1].sprite.setPath(that.leftPaths[balls.length - 1], null)
            balls[balls.length - 1].sprite.startFollow({
                duration: duration,
                from: 0,
                to: 1,
                repeat: 0,
                positionOnPath: true,
                rotateToPath: true,
                onComplete: () => { 
                    const temp = that.spots[that.spots.length - 1].ball 
                    for (let i=that.spots.length - 1; i>0; i--) {
                        that.spots[i].ball = that.spots[i-1].ball
                    }
                    that.spots[0].ball = temp
                    resolve()
                }
            })
        })
    }

    rotateRight(that) {
        that.soundManager.play(that.rightSound)
        return new Promise(resolve => {
            const balls = that.spots.map(spot => spot.ball)
            for (let i=0; i<balls.length - 1; i++) {
                balls[i].sprite.setPath(that.rightPaths[i], null)
                balls[i].sprite.startFollow({
                    duration: duration,
                    from: 0,
                    to: 1,
                    repeat: 0,
                    positionOnPath: true,
                    rotateToPath: true
                })
            }

            balls[balls.length - 1].sprite.setPath(that.rightPaths[balls.length - 1], null)
            balls[balls.length - 1].sprite.startFollow({
                duration: duration,
                from: 0,
                to: 1,
                repeat: 0,
                positionOnPath: true,
                rotateToPath: true,
                onComplete: () => {
                    const temp = that.spots[0].ball 
                    for (let i=0; i<that.spots.length - 1; i++) {
                        that.spots[i].ball = that.spots[i+1].ball
                    }
                    that.spots[that.spots.length - 1].ball = temp
                    resolve()
                }
            })
        })
    }

    createEvents(checkWin) {
        this.sprite.setInteractive({
            hitArea: new Phaser.Geom.Polygon(this.polygon),
            hitAreaCallback: Phaser.Geom.Polygon.Contains,
            useHandCursor: true
        })
        this.sprite.on('pointerover', () => {
            this.sprite.setTint(0xaaaaaa);
        })
        this.sprite.on('pointerout', () => {
            this.sprite.clearTint();
        })
        this.sprite.on('pointerdown', (event) => {
            if (event.position.x - this.origin.x <= this.size.width / 2) {
                this.rotateLeft(this)
                    .then(() => {
                        checkWin()
                    })
            } else {
                this.rotateRight(this)
                    .then(() => {
                        checkWin()
                    })
            }
        })
    }

    destroy() {
        this.sprite.destroy()
        for (let path of this.leftPaths) {
            path.destroy()
        }
        for (let path of this.rightPaths) {
            path.destroy()
        }
    }
}
